import React from 'react';
import { LoginForm } from '../../../components/LoginForm';
// import { useNavigate } from 'react-router-dom'; // if using React Router

export const LoginPage: React.FC = () => {
  // const navigate = useNavigate(); // if using React Router

  const handleLogin = async (data: { email: string; password: string }) => {
    // Here you would typically make an API call to authenticate
    void data; // placeholder — wire to auth API

    // Simulate successful login
    // navigate('/dashboard'); // if using React Router
  };

  return <LoginForm onSubmit={handleLogin} />;
};
